/* Editorial homepage: category index hover swap + reveal on scroll */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const init = () => {
    $$('[data-idx]').forEach(idx => {
      const rows = $$('[data-idx-row]', idx), frames = $$('[data-idx-img]', idx);
      const set = i => {
        rows.forEach(r => r.classList.toggle('is-active', r.dataset.idxRow === i));
        frames.forEach(f => f.classList.toggle('is-active', f.dataset.idxImg === i));
      };
      rows.forEach(r => {
        if (r.dataset.bound) return;
        r.dataset.bound = '1';
        r.addEventListener('mouseenter', () => set(r.dataset.idxRow));
        r.addEventListener('focus', () => set(r.dataset.idxRow));
      });
    });
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return;
    const io = window.__edReveal || (window.__edReveal = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      el.classList.add('is-in');
      io.unobserve(el);
      el.addEventListener('transitionend', () => { el.style.transitionDelay = ''; }, { once: true });
    }), { rootMargin: '0px 0px -10% 0px' }));
    $$('.edf__copy, .ticket, .idx__row, .edr__intro, .man__grid > *').forEach((el, i) => {
      if (el.hasAttribute('data-ed-reveal') || el.getBoundingClientRect().top < innerHeight) return;
      el.setAttribute('data-ed-reveal', '');
      el.style.transitionDelay = (i % 3) * 80 + 'ms';
      io.observe(el);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
